import { render, staticRenderFns } from "./AddNewLossForm.vue?vue&type=template&id=5489f2ab"
import script from "./AddNewLossForm.vue?vue&type=script&lang=ts"
export * from "./AddNewLossForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports